module.exports = __webpack_public_path__ + "static/media/expand_more.3f12c58e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/expand_more.svg
// module id = 980
// module chunks = 0